<script>
import {
  initCaptcha,
  executeCaptcha,
  resetCaptcha,
  isCaptchaEnable,
  mountCaptcha
} from "@/helper/captcha";
import {mapGetters} from "vuex";


export default {
  name: "YandexSmartCapthca",
  inheritAttrs: false,
  props: {
    containerId: String,
    isOnlyNotAuthorized: {
      type: Boolean,
      default: true
    },
    invisible: {
      type: Boolean,
      default: false
    },
    errors: {
      type: Array,
      default: undefined
    }
  },
  data() {
    return {
      captchaLoaded: false,
      isCaptchaInit: false,
      insideError: undefined,
      widgetId: null,
    }
  },
  watch: {
    errors () {
      if (Array.isArray(this.errors))
        this.insideError = this.errors[0]
      else
        this.insideError = this.errors
    },
    captchaLoaded () {
      this.$nextTick(() => {
        this.init()
      })
    },
  },
  computed: {
    isEnable() {
      return isCaptchaEnable() && (this.isOnlyNotAuthorized ? !this.isAuthenticate: true)
    },
    captchaContainerName() {
      return this.containerId !== null ? this.containerId : "default-captcha-container"
    },
    ...mapGetters({
      isAuthenticate: 'auth/isAuthenticated'
    }),
    combinedClass() {
      const staticClass = this.$vnode.data && this.$vnode.data.staticClass;
      const dynamicClass = this.$vnode.data && this.$vnode.data.class;
      return [staticClass, dynamicClass];
    },
    combinedStyle() {
      const staticStyle = this.$vnode.data && this.$vnode.data.staticStyle;
      const dynamicStyle = this.$vnode.data && this.$vnode.data.style;
      return { ...staticStyle, ...dynamicStyle };
    },
  },
  methods: {
    approve(token) {
      this.clear()
      this.$emit('approve', token)
    },
    fail(data) {
      this.insideError = data
      this.reInit()
      this.$emit('fail')
    },
    init() {
      if (this.isEnable) {
        this.isCaptchaInit = true
        this.widgetId = initCaptcha(this.captchaContainerName, this.invisible, (token) => {
          this.approve(token)
        }, (data) => {
          this.fail(data)
        })
      }
    },
    reInit() {
      if (this.widgetId !== undefined && this.widgetId !== null)
        resetCaptcha(this.widgetId)
    },
    clear() {
      this.isCaptchaInit = false
    },
    execute() {
      if (this.isEnable) {
        this.insideError = undefined
        executeCaptcha(this.widgetId)
      } else {
        this.approve(null)
      }
    }
  },
  mounted() {
    mountCaptcha(() => {
        this.captchaLoaded = true;
      },
      (err) => {this.insideError = err}
    )
  }
}
</script>

<template>
  <div>
    <slot name="before" v-bind="{execute, isInit: isCaptchaInit, isEnable}"></slot>
    <v-snackbar :value="!!insideError" color="error" @input="() => insideError = undefined" multi-line>
      {{insideError}}
      <template v-slot:action>
        <v-btn icon @click="insideError = undefined"><v-icon>close</v-icon></v-btn>
      </template>
    </v-snackbar>
    <div :id="captchaContainerName" v-if="isEnable" :style="{...combinedStyle }" :class="combinedClass"></div>
    <slot name="after" v-bind="{execute, isInit: isCaptchaInit, isEnable}"></slot>
  </div>
</template>

<style scoped>

</style>
